module.exports = __webpack_public_path__ + "assets/microsoft-advertising.e79861c4.svg";